type DateField = 'executed' | 'expected';

type Options = {
	dateFrom?: Date;
	dateTo?: Date;
	dateField?: DateField; // default: 'executed'
	vehicle?: { id: string; name?: string };
	componentIds?: string[];
	componentNames?: string[];
	typeId?: string;
	typeName?: string;
	currentState?: string;
	currentStateName?: string;
	// "Manutenções previstas": also list maintenances close to their predicted km / hours
	upcomingKmPercent?: number;
	upcomingHoursPercent?: number;
	// "Manutenções em atraso": also list maintenances already beyond their predicted km / hours
	overdueByMeter?: boolean;
};

export const openMaintenancesList = (opts: Options = {}) => {
	const params = new URLSearchParams();

	if (opts.dateFrom) params.set('dateFrom', opts.dateFrom.toISOString());
	if (opts.dateTo) params.set('dateTo', opts.dateTo.toISOString());
	if (opts.dateField) params.set('dateField', opts.dateField);
	if (opts.vehicle?.id) {
		params.set('vehicleId', opts.vehicle.id);
		if (opts.vehicle.name) params.set('vehicleName', opts.vehicle.name);
	}
	if (opts.componentIds && opts.componentIds.length > 0) {
		opts.componentIds.forEach(id => params.append('componentIds', id));
		if (opts.componentNames) {
			opts.componentNames.forEach(n => params.append('componentNames', n));
		}
	}
	if (opts.typeId) {
		params.set('typeId', opts.typeId);
		if (opts.typeName) params.set('typeName', opts.typeName);
	}
	if (opts.currentState) {
		params.set('currentState', opts.currentState);
		if (opts.currentStateName) params.set('currentStateName', opts.currentStateName);
	}

	if (opts.upcomingKmPercent != null) params.set('kmPercent', String(opts.upcomingKmPercent));
	if (opts.upcomingHoursPercent != null) params.set('hoursPercent', String(opts.upcomingHoursPercent));
	if (opts.overdueByMeter) params.set('overdueByMeter', 'true');

	const qs = params.toString();
	const url = qs ? `/maintenances?${qs}` : '/maintenances';
	window.open(url, '_blank');
};

export default openMaintenancesList;
